import React, { useState, useEffect, useContext, useRef } from 'react';
import { Switch, Route } from 'react-router-dom';
import { atom, useAtom } from 'jotai';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Badge,
    CustomInput,
    CardText,
    ListGroup,
    ListGroupItem,
    Row,
    Col,
    Container,
    FormGroup,
    Label,
    InputGroup,
    Input,
    InputGroupAddon,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    UncontrolledTooltip,
    Form,
    FormFeedback,
    CardFooter,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import classnames from 'classnames';
import { Icon } from '@iconify/react';
import cardAccountDetailsOutline from '@iconify/icons-mdi/card-account-details-outline';
import messageBadgeOutline from '@iconify/icons-mdi/message-badge-outline';
import accountSettingsOutline from '@iconify/icons-mdi/account-settings-outline';
import pencilIcon from '@iconify/icons-mdi/pencil';
import contentSave from '@iconify/icons-mdi/content-save';
import messageSettingsOutline from '@iconify/icons-mdi/message-settings';
import accountGroupOutline from '@iconify/icons-mdi/account-group-outline';
import fileDocumentOutline from '@iconify/icons-mdi/file-document-outline';
import dotsVertical from '@iconify/icons-mdi/dots-vertical';
import officeBuildingOutline from '@iconify/icons-mdi/office-building-outline';
import pharmacyIcon from '@iconify/icons-mdi/pill';
import shieldAccountOutline from '@iconify/icons-mdi/shield-account-outline';
import Notification from './Notification';
import MaskedInput from 'react-text-mask';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { SrxApi } from '../api/SrxApi';
import { UserContext } from '../contexts/UserContext';
import { hasWidgetViewPermission, hasRolePermission } from '../utility-services/rolePermissions';
import { UserRolesContext } from '../contexts/UserRolesContext';
import { SelectedFacilitiesContext } from '../contexts/SelectedFacilitiesContext';
import { ShowResolvedAlertsContext } from '../contexts/ShowResolvedAlertsContexts';
import checkCircle from '@iconify/icons-mdi/check-circle';
import checkBold from '@iconify/icons-mdi/check-bold';
import { confirm } from '../utility-components/ConfirmModal';
import Draggable from 'react-draggable';
import cloneDeep from 'lodash.clonedeep';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
    useSortable,
    arrayMove,
    arraySwap,
    rectSwappingStrategy,
    rectSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { highCostAtomSortOrder } from '../jotai-atoms/AlertAtoms';
import Swal from 'sweetalert2';
import {
    highCostAtomUserSettings,
    highCostAlertsAtomUserSettings,
    clarificationsAtomUserSettings,
    priorAuthAtomUserSettings,
    nonCoveredAtomUserSettings,
    therapeuticIntAtomUserSettings,
    admissionMedsAtomUserSettings,
    refillTooSoonAtomUserSettings,
    pumpPickupAtomUserSettings,
    narcoticsRefillAtomUserSettings,
    alfNewScriptAtomUserSettings,
    alfCostResponseAtomUserSettings,
    hideResolvedAlertsAtomUserSettings,
    unavailableMedicationAlertsAtomUserSettings,
} from '../jotai-atoms/AlertAtoms';

import { GridContextProvider, GridDropZone, GridItem, swap, move } from 'react-grid-dnd';
import { WidgetsData } from '../data/WidgetsData';
import { includes } from 'lodash';
// import FacilitySettingsPage from './FacilitySettings';

const Settings = () => {
    const [activeTab, setActiveTab] = useState('account');
    const { user, logoutUser, setUser, roles } = useContext(UserContext);
    const { facilities } = useContext(SelectedFacilitiesContext);
    const { showResolved } = useContext(ShowResolvedAlertsContext);
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        // navigate to /settings/account by default
        if (location.pathname === '/settings') history.replace('/settings/account');
    }, [location.pathname]);

    // If the user navigates directly to /settings/<tab>, make sure the correct tab is active
    useEffect(() => {
        const m = location.pathname.match(/^\/settings\/(.+)$/);
        if (m && m[1]) setActiveTab(m[1]);
    }, [location.pathname]);

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const navigateSettings = (e, category) => {
        e.preventDefault();
        setActiveTab(category);
        history.push('/settings/' + category);
    };

    const isAdmin = facilities?.some((f) => f?.permissions?.['canSetSettingsForUsers']);

    return (
        <>
            <Card
                style={{ height: 'calc(100vh - 160px)', maxHeight: 'calc(100vh - 160px)', minWidth: 0 }}
                className="mt-2">
                <Row className="h-100 d-flex flex-nowrap">
                    <Col sm={'auto'} className="pr-0 h-100">
                        <Card style={{ minWidth: '300px', width: '300px' }} className="mb-0 shadow h-100">
                            <ListGroup>
                                <ListGroupItem
                                    tag="a"
                                    href="#"
                                    action
                                    className={classnames({ active: activeTab === 'account' })}
                                    onClick={(e) => navigateSettings(e, 'account')}>
                                    <div className="w-100 h-100 d-flex">
                                        <div className="h-100">
                                            <Icon
                                                icon={cardAccountDetailsOutline}
                                                color={activeTab === 'account' ? '#f8f9fa' : '#A2A2A2'}
                                                width="22"
                                                height="22"
                                            />
                                        </div>
                                        <div className="ml-1">
                                            <div>
                                                <strong>Account</strong>
                                            </div>
                                            <small className={activeTab === 'account' ? 'text-light' : 'text-muted'}>
                                                View and update your account details
                                            </small>
                                        </div>
                                    </div>
                                </ListGroupItem>
                                <ListGroupItem
                                    tag="a"
                                    href="#"
                                    action
                                    className={classnames({ active: activeTab === 'specialtyRxNow' })}
                                    onClick={(e) => navigateSettings(e, 'specialtyRxNow')}>
                                    <div className="w-100 h-100 d-flex">
                                        <div className="h-100">
                                            <Icon
                                                icon={messageBadgeOutline}
                                                color={activeTab === 'specialtyRxNow' ? '#f8f9fa' : '#A2A2A2'}
                                                width="22"
                                                height="22"
                                                hFlip={true}
                                            />
                                        </div>
                                        <div className="ml-1">
                                            <div>
                                                <strong>SpecialtyRx Now</strong>
                                                {!!user.mediprocityUser && (
                                                    <Badge color="success" className="text-white ml-1 pt-1">
                                                        Verified
                                                    </Badge>
                                                )}
                                            </div>
                                            <small
                                                className={
                                                    activeTab === 'specialtyRxNow' ? 'text-light' : 'text-muted'
                                                }>
                                                Manage your SpecialtyRx Now credentials
                                            </small>
                                        </div>
                                    </div>
                                </ListGroupItem>
                                <ListGroupItem
                                    tag="a"
                                    href="#"
                                    action
                                    className={classnames({ active: activeTab === 'userSettings' })}
                                    onClick={(e) => navigateSettings(e, 'userSettings')}>
                                    <div className="w-100 h-100 d-flex">
                                        <div className="h-100">
                                            <Icon
                                                icon={accountSettingsOutline}
                                                color={activeTab === 'userSettings' ? '#f8f9fa' : '#A2A2A2'}
                                                width="22"
                                                height="22"
                                                hFlip={true}
                                            />
                                        </div>
                                        <div className="ml-1">
                                            <div>
                                                <strong>User Settings</strong>
                                            </div>
                                            <small
                                                className={activeTab === 'userSettings' ? 'text-light' : 'text-muted'}>
                                                Configure User Settings
                                            </small>
                                        </div>
                                    </div>
                                </ListGroupItem>
                                {hasRolePermission(roles, 'canViewManageRoles') && (
                                    <ListGroupItem
                                        tag="a"
                                        href="#"
                                        action
                                        className={classnames({ active: activeTab === 'manageRoles' })}
                                        onClick={(e) => navigateSettings(e, 'manageRoles')}>
                                        <div className="w-100 h-100 d-flex">
                                            <div className="h-100">
                                                <Icon
                                                    icon={accountGroupOutline}
                                                    color={activeTab === 'manageRoles' ? '#f8f9fa' : '#A2A2A2'}
                                                    width="22"
                                                    height="22"
                                                />
                                            </div>
                                            <div className="ml-1">
                                                <div>
                                                    <strong>Manage Roles</strong>
                                                </div>
                                                <small
                                                    className={
                                                        activeTab === 'manageRoles' ? 'text-light' : 'text-muted'
                                                    }>
                                                    Create and manage roles
                                                </small>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                )}
                                {hasRolePermission(roles, 'canViewManageTemplate') && (
                                    <ListGroupItem
                                        tag="a"
                                        href="#"
                                        action
                                        className={classnames({ active: activeTab === 'manageTemplate' })}
                                        onClick={(e) => navigateSettings(e, 'manageTemplate')}>
                                        <div className="w-100 h-100 d-flex">
                                            <div className="h-100">
                                                <Icon
                                                    icon={fileDocumentOutline}
                                                    color={activeTab === 'manageTemplate' ? '#f8f9fa' : '#A2A2A2'}
                                                    width="22"
                                                    height="22"
                                                />
                                            </div>
                                            <div className="ml-1">
                                                <div>
                                                    <strong>Manage Role Groups</strong>
                                                </div>
                                                <small
                                                    className={
                                                        activeTab === 'manageTemplate' ? 'text-light' : 'text-muted'
                                                    }>
                                                    Create and manage role groups
                                                </small>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                )}
                                {hasRolePermission(roles, 'canViewManageNotification') && (
                                    <ListGroupItem
                                        tag="a"
                                        href="#"
                                        action
                                        className={classnames({ active: activeTab === 'notifications' })}
                                        onClick={(e) => navigateSettings(e, 'notifications')}>
                                        <div className="w-100 h-100 d-flex">
                                            <div className="h-100">
                                                <Icon
                                                    icon={messageSettingsOutline}
                                                    color={activeTab === 'notifications' ? '#f8f9fa' : '#A2A2A2'}
                                                    width="22"
                                                    height="22"
                                                />
                                            </div>
                                            <div className="ml-1">
                                                <div>
                                                    <strong>Notifications</strong>
                                                </div>
                                                <small
                                                    className={
                                                        activeTab === 'notifications' ? 'text-light' : 'text-muted'
                                                    }>
                                                    Manage system notifications
                                                </small>
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                )}
                            </ListGroup>
                        </Card>
                    </Col>
                    <Col style={{ flex: 1, minWidth: 0 }} className="mt-3 ml-4 mr-5 mb-3">
                        <Card
                            className="shadow h-100 w-100"
                            style={{
                                borderRadius: '14px',
                                minWidth: 0,
                                padding: '20px 35px 20px 35px',
                                overflow: 'auto',
                            }}>
                            <Switch>
                                <Route path="/settings/account">
                                    <Account toggle={toggle} />
                                </Route>
                                <Route path="/settings/specialtyRxNow">
                                    <MediprocitySignUp toggle={toggle} />
                                </Route>
                                <Route path="/settings/userSettings">
                                    <UserSettings toggle={toggle} />
                                </Route>
                                {hasRolePermission(roles, 'canViewManageRoles') && (
                                    <Route path="/settings/manageRoles">
                                        <ManageRoles toggle={toggle} />
                                    </Route>
                                )}
                                {hasRolePermission(roles, 'canViewManageTemplate') && (
                                    <Route path="/settings/manageTemplate">
                                        <ManageTemplate toggle={toggle} />
                                    </Route>
                                )}
                                {hasRolePermission(roles, 'canViewManageNotification') && (
                                    <Route path="/settings/notifications">
                                        <Notification toggle={toggle} />
                                    </Route>
                                )}
                                {/* <Route path="/settings/facilitySettings">
                                    <FacilitySettingsPage />
                                </Route> */}
                                {/* <Route path='/omni/settings/files'>
                                <Files toggle={toggle} />
                            </Route>
                            <Route path='/omni/settings/webhooks'>
                                <Webhooks toggle={toggle} />
                            </Route>
                            <Route path='/omni/settings/tax'>
                                <Tax toggle={toggle} />
                            </Route> */}
                            </Switch>
                        </Card>
                    </Col>
                </Row>
            </Card>
        </>
    );
};

const ROLE_ENTITY_OPTIONS = [
    { value: 'facility', label: 'Facility' },
    { value: 'pharmacy', label: 'Pharmacy' },
    { value: 'standardUser', label: 'Standard Role' },
];

const isWidgetGroup = (group) => {
    const suffixes = (group.permissions || []).map((p) => p.permissionName?.trim().split('.').pop().toLowerCase());
    return suffixes.includes('view') && suffixes.includes('ask') && suffixes.includes('fullaccess');
};

const humanizeGroupName = (groupName = '') =>
    groupName
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());

const getGroupPermissionIds = (group) => (group.permissions || []).map((p) => p.permissionId);

const humanizePermissionLabel = (permission, groupName = '') => {
    if (permission.displayName) return permission.displayName;
    const suffix = (permission.permissionName || '').replace(new RegExp('^' + groupName + '\\.', 'i'), '');
    const spaced = suffix.replace(/([a-z])([A-Z])/g, '$1 $2');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

const TriStateCheckbox = ({ checked, indeterminate, onChange, className }) => {
    const inputRef = useRef(null);
    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return <Input type="checkbox" innerRef={inputRef} checked={checked} onChange={onChange} className={className} />;
};

const arraysEqualAsSets = (a, b) => {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((value, index) => value === sortedB[index]);
};

const ManageRoles = (props) => {
    const { toggle } = props;
    const { roles } = useContext(UserContext);
    const canAddRoles = hasRolePermission(roles, 'canAddManageRoles');
    const canEditRoles = hasRolePermission(roles, 'canEditManageRoles');
    const canDeleteRoles = hasRolePermission(roles, 'canDeleteManageRoles');
    const canManagePermissionsRole = hasRolePermission(roles, 'canManagePermissionsRole');
    const [facilityRoles, setFacilityRoles] = useState(null);
    const [pharmacyRoles, setPharmacyRoles] = useState(null);
    const [standardUserRoles, setStandardUserRoles] = useState(null);
    const [showCreateRole, setShowCreateRole] = useState(false);
    const [editingRoleId, setEditingRoleId] = useState(null);
    const [newRoleName, setNewRoleName] = useState('');
    const [newRoleEntity, setNewRoleEntity] = useState(null);
    const [originalRoleData, setOriginalRoleData] = useState(null);
    const [roleModalRole, setRoleModalRole] = useState(null);
    const [availablePermissions, setAvailablePermissions] = useState(null);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [initialSelectedPermissions, setInitialSelectedPermissions] = useState([]);
    const [openPermissionGroups, setOpenPermissionGroups] = useState(new Set());
    const permissionCatalogRef = useRef(null);

    const togglePermissionGroupOpen = (groupName) => {
        setOpenPermissionGroups((prev) => {
            const next = new Set(prev);
            if (next.has(groupName)) next.delete(groupName);
            else next.add(groupName);
            return next;
        });
    };

    useEffect(() => {
        toggle('manageRoles');
    }, []);

    const loadRoles = () => {
        SrxApi.get('/roles', { params: { entity: 'facility' } })
            .then((res) => setFacilityRoles(res.data?.roles || []))
            .catch(() => setFacilityRoles([]));
        SrxApi.get('/roles', { params: { entity: 'pharmacy' } })
            .then((res) => setPharmacyRoles(res.data?.roles || []))
            .catch(() => setPharmacyRoles([]));
        SrxApi.get('/roles', { params: { entity: 'standardUser' } })
            .then((res) => setStandardUserRoles(res.data?.roles || []))
            .catch(() => setStandardUserRoles([]));
    };

    useEffect(() => {
        loadRoles();
    }, []);

    const resetRoleForm = () => {
        setEditingRoleId(null);
        setNewRoleName('');
        setNewRoleEntity(null);
        setOriginalRoleData(null);
    };

    const openCreateRoleModal = () => {
        resetRoleForm();
        setShowCreateRole(true);
    };

    const closeCreateRoleModal = () => {
        setShowCreateRole(false);
        resetRoleForm();
    };

    const handleEditRoleClick = (role, entity) => {
        const roleEntity = ROLE_ENTITY_OPTIONS.find((o) => o.value === entity) || null;
        setEditingRoleId(role.id || role.name);
        setNewRoleName(role.label || role.name);
        setNewRoleEntity(roleEntity);
        setOriginalRoleData({ name: role.label || role.name, entity: roleEntity?.value || null });
        setShowCreateRole(true);
    };

    const isRoleFormUnchanged =
        !!editingRoleId &&
        !!originalRoleData &&
        newRoleName === originalRoleData.name &&
        (newRoleEntity?.value || null) === originalRoleData.entity;

    const getRolesForEntity = (entityValue) => {
        if (entityValue === 'facility') return facilityRoles || [];
        if (entityValue === 'pharmacy') return pharmacyRoles || [];
        if (entityValue === 'standardUser') return standardUserRoles || [];
        return [];
    };

    const isDuplicateRoleName =
        !!newRoleName &&
        !!newRoleEntity &&
        getRolesForEntity(newRoleEntity.value).some((r) => {
            if (editingRoleId && (r.id || r.name) === editingRoleId) return false;
            return (r.label || r.name || '').trim().toLowerCase() === newRoleName.trim().toLowerCase();
        });

    const handleCreateRole = () => {
        if (!newRoleName || !newRoleEntity) {
            toast.error('Please enter a role name and select where it applies');
            return;
        }
        if (isRoleFormUnchanged) {
            toast.error('No changes were made to this role');
            return;
        }
        if (isDuplicateRoleName) {
            toast.error('A role with this name already exists for the selected entity');
            return;
        }
        const payload = {
            name: newRoleName,
            entity: newRoleEntity.value,
            // permission: 'viewOnly',
        };
        const request = editingRoleId
            ? SrxApi.put(`/updaterole/${editingRoleId}`, payload)
            : SrxApi.post('/roles', payload);

        request
            .then(() => {
                toast.success(editingRoleId ? 'Role updated' : 'Role created');
                closeCreateRoleModal();
                loadRoles();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Error saving role: ' + err.message));
    };

    const handleDeleteRole = async (role) => {
        if (role.isDeletable === false) return;

        if (
            !(await confirm(
                `Are you sure you want to delete <b>${role.label || role.name}</b>?`,
                'Delete Role',
                'Delete',
                'Cancel',
                'danger',
                'danger'
            ))
        )
            return;

        SrxApi.delete(`/deleterole/${role.id || role.name}`)
            .then(() => {
                toast.success('Role deleted');
                loadRoles();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Error deleting role: ' + err.message));
    };

    const openManagePermissionsModal = (role) => {
        setRoleModalRole(role);
        setAvailablePermissions(null);
        setSelectedPermissions([]);
        setOpenPermissionGroups(new Set());

        const catalogPromise = permissionCatalogRef.current
            ? Promise.resolve(permissionCatalogRef.current)
            : SrxApi.get('/permissions').then((res) => {
                  const groups = res.data?.permissionGroups || res.data || [];
                  permissionCatalogRef.current = groups;
                  return groups;
              });

        Promise.all([catalogPromise, SrxApi.get(`/permissions/role/${role.id}`)])
            .then(([groups, roleRes]) => {
                setAvailablePermissions(groups);

                const displayableGroups = groups.filter((group) => group.groupName?.toLowerCase() !== 'general');
                const widgetGroups = displayableGroups.filter(isWidgetGroup);
                const pageGroups = displayableGroups.filter((group) => !isWidgetGroup(group));
                const firstGroup = widgetGroups[0] || pageGroups[0];
                setOpenPermissionGroups(firstGroup ? new Set([firstGroup.groupName]) : new Set());

                const roleData = roleRes.data?.permissions || roleRes.data || [];
                const granted = roleData
                    .filter((entry) => entry.hasPermission === true)
                    .map((entry) => entry.permissionId);

                setSelectedPermissions(granted);
                setInitialSelectedPermissions(granted);
            })
            .catch(() => setAvailablePermissions([]));
    };

    const closeManagePermissionsModal = () => {
        setRoleModalRole(null);
        setAvailablePermissions(null);
        setSelectedPermissions([]);
        setInitialSelectedPermissions([]);
    };

    const isPermissionsUnchanged = arraysEqualAsSets(selectedPermissions, initialSelectedPermissions);

    const togglePermission = (permission) => {
        const value = permission.permissionId;
        setSelectedPermissions((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]));
    };

    const handleSavePermissions = () => {
        const permissions = (availablePermissions || [])
            .filter((group) => group.groupName?.toLowerCase() !== 'general')
            .flatMap((group) => group.permissions || [])
            .map((permission) => ({
                permissionId: permission.permissionId,
                permissionName: permission.permissionName,
                hasPermission: selectedPermissions.includes(permission.permissionId),
            }));

        SrxApi.post(`/permissions/role/${roleModalRole.id}`, {
            roleId: roleModalRole.id || roleModalRole.name,
            permissions,
        })
            .then(() => {
                toast.success('Permissions updated');
                closeManagePermissionsModal();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Error saving permissions: ' + err.message));
    };

    const renderRoleRow = (entity) => (role, index) => (
        <ListGroupItem key={index} className="d-flex justify-content-between align-items-center px-3 py-3">
            <div className="d-flex align-items-center">
                <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-light mr-3"
                    style={{ width: '36px', height: '36px', flexShrink: 0 }}>
                    <Icon icon={shieldAccountOutline} width="20" height="20" className="text-muted" />
                </div>
                <div>
                    <div className="font-weight-bold">{role.label || role.name}</div>
                    {role.description && <small className="text-muted">{role.description}</small>}
                </div>
            </div>
            {(canEditRoles || canDeleteRoles || canManagePermissionsRole) && (
                <UncontrolledDropdown>
                    <DropdownToggle
                        tag="span"
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{ cursor: 'pointer', width: '32px', height: '32px' }}>
                        <Icon icon={dotsVertical} width="20" height="20" className="text-muted" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        {canEditRoles && (
                            <DropdownItem onClick={() => handleEditRoleClick(role, entity)}>Edit</DropdownItem>
                        )}
                        {canDeleteRoles && (
                            <>
                                <span id={`delete-role-btn-${entity}-${role.id || role.name}`} className="d-block">
                                    <DropdownItem
                                        disabled={role.isDeletable === false}
                                        onClick={() => handleDeleteRole(role)}>
                                        Delete
                                    </DropdownItem>
                                </span>
                                {role.isDeletable === false && (
                                    <UncontrolledTooltip
                                        placement="left"
                                        target={`delete-role-btn-${entity}-${role.id || role.name}`}>
                                        This role is assigned and cannot be deleted
                                    </UncontrolledTooltip>
                                )}
                            </>
                        )}
                        {canManagePermissionsRole && (
                            <DropdownItem onClick={() => openManagePermissionsModal(role)}>
                                Manage Permissions
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
        </ListGroupItem>
    );

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Manage Roles</h4>
                {/* {canAddRoles && ( */}
                <Button color="primary" outline onClick={openCreateRoleModal}>
                    + Create New Role
                </Button>
                {/* )} */}
            </div>

            <Modal isOpen={showCreateRole} toggle={closeCreateRoleModal}>
                <ModalHeader toggle={closeCreateRoleModal}>
                    {editingRoleId ? 'Edit Role' : 'Create New Role'}
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Role Name</Label>
                            <Input
                                type="text"
                                placeholder="e.g. All Alerts Viewer"
                                value={newRoleName}
                                onChange={(e) => setNewRoleName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Applies To</Label>
                            <Select
                                placeholder="Select Facility, Pharmacy or Standard Role..."
                                isSearchable={false}
                                value={newRoleEntity}
                                onChange={setNewRoleEntity}
                                options={ROLE_ENTITY_OPTIONS}
                            />
                        </FormGroup>
                        {isDuplicateRoleName && (
                            <div className="invalid-text">This role already exists for the selected entity</div>
                        )}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeCreateRoleModal}>
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleCreateRole}
                        disabled={isRoleFormUnchanged || isDuplicateRoleName}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            <Card className="mb-4 shadow-sm border-0">
                <CardHeader className="bg-white d-flex align-items-center">
                    <Icon icon={officeBuildingOutline} width="18" height="18" className="text-muted mr-2" />
                    <span className="font-weight-bold">Facility Roles</span>
                </CardHeader>
                <ListGroup flush>
                    {!facilityRoles && (
                        <div className="text-muted p-3">
                            <div className="bouncing-loader">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    )}
                    {facilityRoles?.length === 0 && <div className="text-muted p-3">No facility roles</div>}
                    {facilityRoles?.map(renderRoleRow('facility'))}
                </ListGroup>
            </Card>

            <Card className="shadow-sm border-0">
                <CardHeader className="bg-white d-flex align-items-center">
                    <Icon icon={pharmacyIcon} width="18" height="18" className="text-muted mr-2" />
                    <span className="font-weight-bold">Pharmacy Roles</span>
                </CardHeader>
                <ListGroup flush>
                    {!pharmacyRoles && (
                        <div className="text-muted p-3">
                            {' '}
                            <div className="bouncing-loader">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    )}
                    {pharmacyRoles?.length === 0 && <div className="text-muted p-3">No pharmacy roles</div>}
                    {pharmacyRoles?.map(renderRoleRow('pharmacy'))}
                </ListGroup>
            </Card>

            <Card className="shadow-sm border-0">
                <CardHeader className="bg-white d-flex align-items-center">
                    <Icon icon={shieldAccountOutline} width="18" height="18" className="text-muted mr-2" />
                    <span className="font-weight-bold">Standard Roles</span>
                </CardHeader>
                <ListGroup flush>
                    {!standardUserRoles && (
                        <div className="text-muted p-3">
                            {' '}
                            <div className="bouncing-loader">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    )}
                    {standardUserRoles?.length === 0 && <div className="text-muted p-3">No standard roles</div>}
                    {standardUserRoles?.map(renderRoleRow('standardUser'))}
                </ListGroup>
            </Card>

            <Modal
                isOpen={!!roleModalRole}
                toggle={closeManagePermissionsModal}
                size="lg"
                style={{ maxWidth: '650px' }}>
                <ModalHeader toggle={closeManagePermissionsModal} style={{ borderBottom: '1px solid #e9ecef' }}>
                    {roleModalRole?.label || roleModalRole?.name}
                </ModalHeader>
                <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {!availablePermissions && (
                        <div className="bouncing-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    )}
                    {availablePermissions?.length === 0 && <div className="text-muted">No permissions available</div>}
                    {availablePermissions?.length > 0 &&
                        (() => {
                            const displayableGroups = availablePermissions.filter(
                                (group) => group.groupName?.toLowerCase() !== 'general'
                            );
                            const widgetGroups = displayableGroups.filter(isWidgetGroup);
                            const pageGroups = displayableGroups.filter((group) => !isWidgetGroup(group));

                            const allPermissionIds = displayableGroups.flatMap((group) => getGroupPermissionIds(group));
                            const isEverythingSelected =
                                allPermissionIds.length > 0 &&
                                allPermissionIds.every((id) => selectedPermissions.includes(id));

                            const handleSelectAllToggle = () => {
                                if (isEverythingSelected) {
                                    setSelectedPermissions((prev) =>
                                        prev.filter((id) => !allPermissionIds.includes(id))
                                    );
                                } else {
                                    setSelectedPermissions((prev) => [...new Set([...prev, ...allPermissionIds])]);
                                }
                            };

                            const renderGroupRow = (group) => {
                                const isOpen = openPermissionGroups.has(group.groupName);
                                const groupIds = getGroupPermissionIds(group);
                                const selectedCount = groupIds.filter((id) => selectedPermissions.includes(id)).length;
                                const allSelected = groupIds.length > 0 && selectedCount === groupIds.length;
                                const someSelected = selectedCount > 0 && !allSelected;

                                const handleGroupCheckboxChange = () => {
                                    if (allSelected) {
                                        setSelectedPermissions((prev) => prev.filter((id) => !groupIds.includes(id)));
                                    } else {
                                        setSelectedPermissions((prev) => [...new Set([...prev, ...groupIds])]);
                                    }
                                };

                                const childPermissions = (group.permissions || []).filter(
                                    (perm) =>
                                        perm.permissionName?.trim().split('.').pop().toLowerCase() !== 'viewothers'
                                );

                                return (
                                    <div key={group.groupName} className="perm-tree-node py-1">
                                        <div style={{ paddingBottom: '4px' }} className="d-flex align-items-center">
                                            <i
                                                className={
                                                    'mdi ' +
                                                    (isOpen ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline') +
                                                    ' font-18 mr-2'
                                                }
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => togglePermissionGroupOpen(group.groupName)}
                                            />
                                            <TriStateCheckbox
                                                checked={allSelected}
                                                indeterminate={someSelected}
                                                onChange={handleGroupCheckboxChange}
                                                className="position-static ml-0 mr-2 mt-0"
                                            />
                                            <i
                                                className={
                                                    'mdi ' +
                                                    (isOpen ? 'mdi-folder-open' : 'mdi-folder') +
                                                    ' font-18 mr-2'
                                                }
                                                style={{ cursor: 'pointer', color: '#3b86ff' }}
                                                onClick={() => togglePermissionGroupOpen(group.groupName)}
                                            />
                                            <span
                                                style={{ cursor: 'pointer', fontSize: '18px', fontWeight: 600 }}
                                                onClick={() => togglePermissionGroupOpen(group.groupName)}>
                                                {humanizeGroupName(group.groupName)}
                                            </span>
                                        </div>
                                        {isOpen && (
                                            <div className="perm-tree-list">
                                                {childPermissions.map((perm) => (
                                                    <div className="perm-tree-node py-1" key={perm.permissionId}>
                                                        <FormGroup check className="mb-0">
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    checked={selectedPermissions.includes(
                                                                        perm.permissionId
                                                                    )}
                                                                    onChange={() => togglePermission(perm)}
                                                                />{' '}
                                                                {humanizePermissionLabel(perm, group.groupName)}
                                                            </Label>
                                                        </FormGroup>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                );
                            };

                            if (displayableGroups.length === 0) {
                                return <div className="text-muted">No permissions available</div>;
                            }

                            return (
                                <>
                                    {displayableGroups.length > 0 && (
                                        <div className="d-flex justify-content-end mb-3">
                                            <Button
                                                color="link"
                                                size="sm"
                                                className="p-0"
                                                onClick={handleSelectAllToggle}>
                                                {isEverythingSelected ? 'Deselect All' : 'Select All'}
                                            </Button>
                                        </div>
                                    )}
                                    {widgetGroups.length > 0 && (
                                        <div className="mb-4">
                                            <h6 className="font-weight-bold border-bottom pb-2 mb-3">Widgets</h6>
                                            <div className="perm-tree-list">{widgetGroups.map(renderGroupRow)}</div>
                                        </div>
                                    )}
                                    {pageGroups.length > 0 && (
                                        <div>
                                            <h6 className="font-weight-bold border-bottom pb-2 mb-3">Pages</h6>
                                            <div className="perm-tree-list">{pageGroups.map(renderGroupRow)}</div>
                                        </div>
                                    )}
                                </>
                            );
                        })()}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeManagePermissionsModal}>
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleSavePermissions}
                        disabled={!availablePermissions || isPermissionsUnchanged}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

const capitalizeFirstLetter = (str = '') => (str ? str.charAt(0).toUpperCase() + str.slice(1) : str);

const ManageTemplate = (props) => {
    const { toggle } = props;
    const { facilityUserRoles, pharmacyUserRoles } = useContext(UserRolesContext);
    const { roles } = useContext(UserContext);
    const canAddTemplate = hasRolePermission(roles, 'canCreateManageTemplate');
    const canEditTemplate = hasRolePermission(roles, 'canEditManageTemplate');
    const canDeleteTemplate = hasRolePermission(roles, 'canDeleteManageTemplate');
    const [templates, setTemplates] = useState(null);
    const [showCreateTemplate, setShowCreateTemplate] = useState(false);
    const [editingTemplateId, setEditingTemplateId] = useState(null);
    const [templateName, setTemplateName] = useState('');
    const [description, setDescription] = useState('');
    const [entity, setEntity] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [originalTemplateData, setOriginalTemplateData] = useState(null);

    useEffect(() => {
        toggle('manageTemplate');
    }, []);

    const loadTemplates = () => {
        SrxApi.get('/roletemplates')
            .then((res) => setTemplates(res.data?.roleTemplates || res.data || []))
            .catch(() => setTemplates([]));
    };

    useEffect(() => {
        loadTemplates();
    }, []);

    const ENTITY_OPTIONS = [
        { value: 'facility', label: 'Facility' },
        { value: 'pharmacy', label: 'Pharmacy' },
    ];

    const duplicateTemplate = (() => {
        if (!entity || !selectedRoles.length || !templates?.length) return null;

        const picked = selectedRoles.map((r) => r.value.toLowerCase());

        return templates
            .filter((t) => (t.roleTemplateId ?? t.id) !== editingTemplateId && t.entity?.toLowerCase() === entity.value)
            .map((t) => ({
                name: t.templateName || t.name,
                roles: (t.userRoles || []).map((r) => (typeof r === 'string' ? r : r.role)?.toLowerCase()),
            }))
            .find((t) => t.roles.length === picked.length && picked.every((r) => t.roles.includes(r)));
    })();

    const roleOptions = entity?.value === 'pharmacy' ? pharmacyUserRoles || [] : facilityUserRoles || [];

    const resetTemplateForm = () => {
        setEditingTemplateId(null);
        setTemplateName('');
        setDescription('');
        setEntity(null);
        setSelectedRoles([]);
        setOriginalTemplateData(null);
    };

    const openCreateModal = () => {
        resetTemplateForm();
        setShowCreateTemplate(true);
    };

    const closeTemplateModal = () => {
        setShowCreateTemplate(false);
        resetTemplateForm();
    };

    const handleEditClick = (template) => {
        const allRoleOptions = [...(facilityUserRoles || []), ...(pharmacyUserRoles || [])];
        const matchedRoles = (template.userRoles || []).map((entry) => {
            const roleName = typeof entry === 'string' ? entry : entry.role;
            return allRoleOptions.find((r) => r.value === roleName) || { value: roleName, label: roleName };
        });
        const matchedEntity = ENTITY_OPTIONS.find((e) => e.value === template.entity?.toLowerCase()) || null;
        setEditingTemplateId(template.roleTemplateId ?? template.id);
        setTemplateName(template.templateName || template.name || '');
        setDescription(template.description || '');
        setEntity(matchedEntity);
        setSelectedRoles(matchedRoles);
        setOriginalTemplateData({
            templateName: template.templateName || template.name || '',
            description: template.description || '',
            entity: matchedEntity?.value || null,
            roles: matchedRoles.map((r) => r.value),
        });
        setShowCreateTemplate(true);
    };

    const isTemplateFormUnchanged =
        !!editingTemplateId &&
        !!originalTemplateData &&
        templateName === originalTemplateData.templateName &&
        (description || '') === originalTemplateData.description &&
        (entity?.value || null) === originalTemplateData.entity &&
        arraysEqualAsSets(
            selectedRoles.map((r) => r.value),
            originalTemplateData.roles
        );

    const handleSave = () => {
        if (!templateName || !entity || !selectedRoles.length) {
            toast.error('Please enter a role group name, pick an entity and select at least one role');
            return;
        }
        if (isTemplateFormUnchanged) {
            toast.error('No changes were made to this role group');
            return;
        }
        const payload = {
            templateName: templateName,
            description: description || undefined,
            entity: entity.value,
            userRoles: selectedRoles.map((r) => r.value),
        };
        const request = editingTemplateId
            ? SrxApi.put(`/roletemplate/${editingTemplateId}`, payload)
            : SrxApi.post('/roletemplate', payload);

        request
            .then(() => {
                toast.success(editingTemplateId ? 'Role group updated' : 'Role group saved');
                closeTemplateModal();
                loadTemplates();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Error saving role group: ' + err.message));
    };

    const handleDeleteTemplate = async (template) => {
        if (template.isDeletable === false) return;

        if (
            !(await confirm(
                `Are you sure you want to delete <b>${capitalizeFirstLetter(
                    template.templateName || template.name
                )}</b>?`,
                'Delete Role Group',
                'Delete',
                'Cancel',
                'danger',
                'danger'
            ))
        )
            return;

        SrxApi.delete(`/roletemplate/${template.roleTemplateId ?? template.id}`)
            .then(() => {
                toast.success('Role group deleted');
                loadTemplates();
            })
            .catch((err) => toast.error(err.response?.data?.message || 'Error deleting role group: ' + err.message));
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0">Manage Role Groups</h4>
                {canAddTemplate && (
                    <Button color="primary" outline onClick={openCreateModal}>
                        + Create New Role Group
                    </Button>
                )}
            </div>

            <Modal isOpen={showCreateTemplate} toggle={closeTemplateModal}>
                <ModalHeader toggle={closeTemplateModal}>
                    {editingTemplateId ? 'Edit Role Group' : 'Create New Role Group'}
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Role Group Name</Label>
                            <Input
                                type="text"
                                placeholder="e.g. All Alerts Viewer"
                                value={templateName}
                                onChange={(e) => setTemplateName(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Description (optional)</Label>
                            <Input
                                type="textarea"
                                placeholder="What is this role group for?"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                style={{ minHeight: '100px', resize: 'none' }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Entity</Label>
                            <Select
                                placeholder="Select entity..."
                                value={entity}
                                onChange={(selection) => {
                                    setEntity(selection);
                                    // roles from the previous entity aren't valid for the new one
                                    setSelectedRoles([]);
                                }}
                                options={ENTITY_OPTIONS}
                                styles={{
                                    control: (base) => ({ ...base, minHeight: '45px' }),
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Roles</Label>
                            <Select
                                isMulti
                                placeholder={
                                    entity
                                        ? `Select ${entity.label.toLowerCase()} roles...`
                                        : 'Select an entity first...'
                                }
                                isDisabled={!entity}
                                isLoading={!facilityUserRoles || !pharmacyUserRoles}
                                value={selectedRoles}
                                onChange={(selection) => setSelectedRoles(selection || [])}
                                options={roleOptions}
                                styles={{
                                    control: (base) => ({ ...base, minHeight: '45px' }),
                                }}
                            />
                            {duplicateTemplate && (
                                <div className="mt-2 p-2 rounded" style={{ backgroundColor: '#FDECEA' }}>
                                    <small>
                                        A role group with exactly these roles already exists —{' '}
                                        <b>{capitalizeFirstLetter(duplicateTemplate.name)}</b>. Use that one instead of
                                        creating a new role group.
                                    </small>
                                </div>
                            )}
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeTemplateModal}>
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        disabled={!!duplicateTemplate}
                        title={
                            duplicateTemplate
                                ? `"${capitalizeFirstLetter(duplicateTemplate.name)}" already has these exact roles`
                                : undefined
                        }
                        onClick={handleSave}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>

            {(() => {
                const facilityTemplates = templates?.filter((t) => t.entity?.toLowerCase() === 'facility');
                const pharmacyTemplates = templates?.filter((t) => t.entity?.toLowerCase() === 'pharmacy');

                const renderTemplateRow = (template, index) => (
                    <ListGroupItem key={index} className="d-flex justify-content-between align-items-start py-3">
                        <div>
                            <div className="font-weight-bold">
                                {capitalizeFirstLetter(template.templateName || template.name)}
                            </div>
                            {template.description && (
                                <small className="text-muted d-block mt-1">{template.description}</small>
                            )}
                            {template.userRoles?.length > 0 && (
                                <div className="mt-2">
                                    {template.userRoles.map((role, roleIndex) => (
                                        <Badge key={roleIndex} color="secondary" className="mr-1 mb-1">
                                            {typeof role === 'string' ? role : role.role}
                                        </Badge>
                                    ))}
                                </div>
                            )}
                        </div>
                        {(canEditTemplate || canDeleteTemplate) && (
                            <UncontrolledDropdown>
                                <DropdownToggle tag="span" style={{ cursor: 'pointer' }}>
                                    <Icon icon={dotsVertical} width="20" height="20" />
                                </DropdownToggle>
                                <DropdownMenu right>
                                    {canEditTemplate && (
                                        <DropdownItem onClick={() => handleEditClick(template)}>Edit</DropdownItem>
                                    )}
                                    {canDeleteTemplate && (
                                        <>
                                            <span
                                                id={`delete-template-btn-${template.roleTemplateId ?? template.id ?? index}`}
                                                className="d-block">
                                                <DropdownItem
                                                    disabled={template.isDeletable === false}
                                                    onClick={() => handleDeleteTemplate(template)}>
                                                    Delete
                                                </DropdownItem>
                                            </span>
                                            {template.isDeletable === false && (
                                                <UncontrolledTooltip
                                                    placement="left"
                                                    target={`delete-template-btn-${template.roleTemplateId ?? template.id ?? index}`}>
                                                    This role group is assigned to one or more users
                                                </UncontrolledTooltip>
                                            )}
                                        </>
                                    )}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        )}
                    </ListGroupItem>
                );

                return (
                    <>
                        <Card className="mb-4 shadow-sm border-0">
                            <CardHeader className="bg-white d-flex align-items-center">
                                <Icon icon={officeBuildingOutline} width="18" height="18" className="text-muted mr-2" />
                                <span className="font-weight-bold">Facility Role Groups</span>
                            </CardHeader>
                            <ListGroup flush>
                                {!templates && (
                                    <div className="text-muted p-3">
                                        <div className="bouncing-loader">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                )}
                                {facilityTemplates?.length === 0 && (
                                    <div className="text-muted p-3">No facility role groups</div>
                                )}
                                {facilityTemplates?.map(renderTemplateRow)}
                            </ListGroup>
                        </Card>

                        <Card className="shadow-sm border-0">
                            <CardHeader className="bg-white d-flex align-items-center">
                                <Icon icon={pharmacyIcon} width="18" height="18" className="text-muted mr-2" />
                                <span className="font-weight-bold">Pharmacy Role Groups</span>
                            </CardHeader>
                            <ListGroup flush>
                                {!templates && (
                                    <div className="text-muted p-3">
                                        <div className="bouncing-loader">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                )}
                                {pharmacyTemplates?.length === 0 && (
                                    <div className="text-muted p-3">No pharmacy role groups</div>
                                )}
                                {pharmacyTemplates?.map(renderTemplateRow)}
                            </ListGroup>
                        </Card>
                    </>
                );
            })()}
        </>
    );
};

const Account = (props) => {
    const { user, setUser } = useContext(UserContext);
    console.log(user);

    const [accountInfo, setAccountInfo] = useState({
        displayName: user.displayName,
        email: user.email,
        phone: user.phone,
        title: user.userTitle,
    });

    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);

    function toggleResetPasswordModal() {
        setIsResetPasswordModalOpen(!isResetPasswordModalOpen);
    }

    const [enableEditFields, setEnableEditFields] = useState({
        displayName: false,
        phone: false,
        title: false,
    });

    const { toggle } = props;

    useEffect(() => {
        toggle('account');
    }, []);

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function editUser(field) {
        // if(field === 'phone' && accountInfo.phone.replace(/\D/g,'').length < 10)
        //     return toast.error('Invalid Phone Number')
        if (enableEditFields[field]) {
            console.log(user.userTitle);
            let payload = {
                email: user.email,
                title: user.userTitle,
                [field]: field === 'phone' ? accountInfo[field].replace(/\D/g, '') : accountInfo[field],
            };

            SrxApi.post('/edituserinfo', payload)
                .then((res) => {
                    toast.success((field === 'displayName' ? 'User name' : 'User phone') + ' updated');
                    setUser(res.data.userInfo);
                    setEnableEditFields({
                        ...enableEditFields,
                        [field]: false,
                    });
                    console.log(res.data.userInfo);
                })
                .catch((err) => toast.error('Error: ' + err.message));
        } else {
            setEnableEditFields({
                ...enableEditFields,
                [field]: true,
            });
        }
    }

    function formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = match[1] ? '+1 ' : '';
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return phoneNumberString;
    }

    return (
        <>
            <Container
                className="mt-5 mb-2 w-50 px-5 py-3 border border-light shadow-sm"
                style={{ borderRadius: '14px', minWidth: 'max-content' }}>
                <h3>Account Info</h3>
                <hr />
                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <Label>Email:</Label>
                            <p style={{ fontSize: '18px', whiteSpace: 'nowrap' }}>
                                <b>
                                    <i>{accountInfo.email}</i>
                                </b>
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="border-top mb-2" style={{ height: '1px', width: '250px' }}></div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {enableEditFields.displayName ? (
                            <FormGroup>
                                <Label for="displayName">Name:</Label>
                                <InputGroup style={{ width: '250px' }}>
                                    <Input
                                        type="text"
                                        name="displayName"
                                        id="displayName"
                                        value={accountInfo.displayName}
                                        onChange={(e) =>
                                            setAccountInfo({
                                                ...accountInfo,
                                                displayName: e.target.value,
                                            })
                                        }
                                        disabled={!enableEditFields.displayName}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <span
                                            className="btn btn-secondary input-group-text py-0 px-1"
                                            onClick={() => editUser('displayName')}>
                                            <Icon
                                                icon={!enableEditFields.displayName ? pencilIcon : contentSave}
                                                width="25"
                                                height="25"
                                            />
                                        </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        ) : (
                            <FormGroup className="edit-account-field">
                                <Label for="displayName">
                                    Name:
                                    <Button
                                        color="link"
                                        className="ml-1 p-0"
                                        onClick={() =>
                                            setEnableEditFields({
                                                ...enableEditFields,
                                                displayName: true,
                                            })
                                        }>
                                        edit
                                    </Button>
                                </Label>
                                <p style={{ fontSize: '18px', whiteSpace: 'nowrap' }}>
                                    <b>{accountInfo.displayName}</b>
                                </p>
                            </FormGroup>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="border-top mb-2" style={{ height: '1px', width: '250px' }}></div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {enableEditFields.phone ? (
                            <FormGroup>
                                <Label for="phone">Phone:</Label>
                                <InputGroup style={{ width: '250px' }}>
                                    <MaskedInput
                                        name="phone"
                                        value={accountInfo.phone}
                                        onChange={(e) =>
                                            setAccountInfo({
                                                ...accountInfo,
                                                phone: e.target.value,
                                            })
                                        }
                                        disabled={!enableEditFields.phone}
                                        mask={[
                                            '(',
                                            /[1-9]/,
                                            /\d/,
                                            /\d/,
                                            ')',
                                            ' ',
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            '-',
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                            /\d/,
                                        ]}
                                        placeholder="(xxx) xxxx-xxxx"
                                        className="form-control"
                                    />
                                    <InputGroupAddon addonType="append">
                                        <span
                                            className="btn btn-secondary input-group-text py-0 px-1"
                                            onClick={() => editUser('phone')}>
                                            <Icon
                                                icon={!enableEditFields.phone ? pencilIcon : contentSave}
                                                width="25"
                                                height="25"
                                            />
                                        </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        ) : (
                            <FormGroup className="edit-account-field">
                                <Label for="phone">
                                    Phone:
                                    <Button
                                        color="link"
                                        className="ml-1 p-0"
                                        onClick={() =>
                                            setEnableEditFields({
                                                ...enableEditFields,
                                                phone: true,
                                            })
                                        }>
                                        edit
                                    </Button>
                                </Label>
                                <p style={{ fontSize: '18px', whiteSpace: 'nowrap' }}>
                                    <b>{formatPhoneNumber(accountInfo.phone.replace(/\D/g, ''))}</b>
                                </p>
                            </FormGroup>
                        )}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="border-top mb-2" style={{ height: '1px', width: '250px' }}></div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <Label>Password:</Label>
                            <p>
                                <Button color="link" className="px-0" onClick={toggleResetPasswordModal}>
                                    Reset Password
                                </Button>
                            </p>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {enableEditFields.title ? (
                            <FormGroup>
                                <Label for="title">Title:</Label>
                                <InputGroup style={{ width: '250px' }}>
                                    <Input
                                        type="text"
                                        name="title"
                                        id="title"
                                        value={accountInfo.title}
                                        onChange={(e) =>
                                            setAccountInfo({
                                                ...accountInfo,
                                                title: e.target.value,
                                            })
                                        }
                                        disabled={!enableEditFields.title}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <span
                                            className="btn btn-secondary input-group-text py-0 px-1"
                                            onClick={() => editUser('title')}>
                                            <Icon
                                                icon={!enableEditFields.title ? pencilIcon : contentSave}
                                                width="25"
                                                height="25"
                                            />
                                        </span>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        ) : (
                            <FormGroup className="edit-account-field">
                                <Label for="title">
                                    Title:
                                    <Button
                                        color="link"
                                        className="ml-1 p-0"
                                        onClick={() =>
                                            setEnableEditFields({
                                                ...enableEditFields,
                                                title: true,
                                            })
                                        }>
                                        edit
                                    </Button>
                                </Label>
                                <p style={{ fontSize: '18px', whiteSpace: 'nowrap' }}>
                                    <b>{accountInfo.title}</b>
                                </p>
                            </FormGroup>
                        )}
                    </Col>
                </Row>
                <ResetPasswordModal isOpen={isResetPasswordModalOpen} toggle={toggleResetPasswordModal} user={user} />
            </Container>
        </>
    );
};

const UserSettings = (props) => {
    const { user, logoutUser, setUser, roles } = useContext(UserContext);
    const { showResolved } = useContext(ShowResolvedAlertsContext);
    const { setShowResolved } = useContext(ShowResolvedAlertsContext);

    const [highCostUserSettings, setHighCostUserSettings] = useAtom(highCostAtomUserSettings);
    const [highCostAlertsUserSettings, setHighCostAlertsUserSettings] = useAtom(highCostAlertsAtomUserSettings);
    const [nonCoveredUserSettings, setNonCoveredUserSettings] = useAtom(nonCoveredAtomUserSettings);
    const [clarificationsUserSettings, setClarificationsUserSettings] = useAtom(clarificationsAtomUserSettings);
    const [priorAuthUserSettings, setPriorAuthUserSettings] = useAtom(priorAuthAtomUserSettings);
    const [therapeuticIntUserSettings, setTherapeuticIntUserSettings] = useAtom(therapeuticIntAtomUserSettings);
    const [admissionMedsUserSettings, setAdmissionMedsUserSettings] = useAtom(admissionMedsAtomUserSettings);
    const [refillTooSoonUserSettings, setRefillTooSoonUserSettings] = useAtom(refillTooSoonAtomUserSettings);
    const [pumpPickupUserSettings, setPumpPickupUserSettings] = useAtom(pumpPickupAtomUserSettings);
    const [narcoticsRefillUserSettings, setNarcoticsRefillUserSettings] = useAtom(narcoticsRefillAtomUserSettings);
    const [alfNewScriptUserSettings, setAlfNewScriptUserSettings] = useAtom(alfNewScriptAtomUserSettings);
    const [alfCostResponseUserSettings, setAlfCostResponseUserSettings] = useAtom(alfCostResponseAtomUserSettings);
    const [hideResolvedAlerts, setHideResolvedAlerts] = useAtom(hideResolvedAlertsAtomUserSettings);
    const [unavailableMedicationAlertsUserSettings, setUnavailableMedicationAlertsUserSettings] = useAtom(
        unavailableMedicationAlertsAtomUserSettings
    );
    let history = useHistory();
    let alertTables = [
        {
            index: highCostUserSettings.sortOrder,
            id: 1,
            name: 'AUTHORIZATION',
            value: 'highCost',
            permissionWidgetName: 'highCost',
            hidden: highCostUserSettings.hidden,
        },
        {
            index: clarificationsUserSettings.sortOrder,
            id: 2,
            name: 'CLARIFICATIONS',
            value: 'openBatch',
            permissionWidgetName: 'openBatch',
            hidden: clarificationsUserSettings.hidden,
        },
        {
            index: nonCoveredUserSettings.sortOrder,
            id: 3,
            name: 'NON-COVERED',
            value: 'nonCovered',
            permissionWidgetName: 'nonCovered',
            hidden: nonCoveredUserSettings.hidden,
        },
        {
            index: priorAuthUserSettings.sortOrder,
            id: 4,
            name: 'PRIOR AUTHORIZATION MEDICATION',
            value: 'priorAuth',
            permissionWidgetName: 'priorAuth',
            hidden: priorAuthUserSettings.hidden,
        },
        {
            index: therapeuticIntUserSettings.sortOrder,
            id: 5,
            name: 'THERAPEUTIC INTERCHANGED',
            value: 'theraInt',
            permissionWidgetName: 'theraInt',
            hidden: therapeuticIntUserSettings.hidden,
        },
        {
            index: admissionMedsUserSettings.sortOrder,
            id: 6,
            name: 'ADMISSION / MEDICATION REVIEW',
            value: 'admissionMeds',
            permissionWidgetName: 'admissionMeds',
            hidden: admissionMedsUserSettings.hidden,
        },
        {
            index: highCostAlertsUserSettings.sortOrder,
            id: 7,
            name: 'HIGH COST ALERTS',
            value: 'highCostAlerts',
            permissionWidgetName: 'highcostalerts',
            hidden: highCostAlertsUserSettings.hidden,
        },
        // refill too soon
        {
            index: refillTooSoonUserSettings.sortOrder,
            id: 8,
            name: 'REFILL TOO SOON',
            value: 'refillTooSoon',
            permissionWidgetName: 'refillTooSoon',
            hidden: refillTooSoonUserSettings.hidden,
            // hidden:
        },
        {
            index: pumpPickupUserSettings.sortOrder,
            id: 9,
            name: 'PUMP PICKUP',
            value: 'pumpPickup',
            permissionWidgetName: 'pumpPickup',
            hidden: pumpPickupUserSettings.hidden,
        },
        {
            index: narcoticsRefillUserSettings.sortOrder,
            id: 9,
            name: 'NARCOTICS REFILL',
            value: 'narcoticsRefill',
            permissionWidgetName: 'narcoticsRefill',
            hidden: narcoticsRefillUserSettings.hidden,
        },
        {
            index: alfNewScriptUserSettings.sortOrder,
            id: 10,
            name: 'ALF - NEW SCRIPT NEEDED',
            value: 'alfNewScript',
            permissionWidgetName: 'alfNewScript',
            hidden: alfNewScriptUserSettings.hidden,
        },
        {
            index: alfCostResponseUserSettings.sortOrder,
            id: 12,
            name: 'ALF High Cost Alerts',
            value: 'alfCostResponse',
            permissionWidgetName: 'alfCostResponse',
            hidden: alfCostResponseUserSettings.hidden,
        },
        {
            index: unavailableMedicationAlertsUserSettings.sortOrder,
            id: 13,
            name: 'UNAVAILABLE MEDICATION',
            value: 'unavailableMedicationAlerts',
            permissionWidgetName: 'unavailableMedicationAlerts',
            hidden: unavailableMedicationAlertsUserSettings.hidden,
        },
        {
            index: hideResolvedAlerts.sortOrder,
            id: 11,
            name: 'Hide Resolved Alerts',
            value: 'hideResolvedAlerts',
            hidden: hideResolvedAlerts.hidden,
        },
    ];

    alertTables = alertTables.filter((item) => hasWidgetViewPermission(roles, item.permissionWidgetName));

    const { toggle } = props;
    const [localData, setLocalData] = useState(alertTables);
    console.log(alertTables);
    console.log(localData);
    useEffect(() => {
        toggle('userSettings');
    }, []);

    // initialize hideResolvedAlerts from server-side user settings so toggle reflects DB
    useEffect(() => {
        if (!user || !user.userSettings) return;

        // user.userSettings may be an object map (widget_hideResolvedAlerts_Show: 'true')
        const settings = user.userSettings;
        const widgetShow = settings?.widget_hideResolvedAlerts_Show ?? settings?.['widget_hideResolvedAlerts_Show'];
        const hideValue =
            widgetShow === undefined ? hideResolvedAlerts.hidden : !(widgetShow === 'true' || widgetShow === true);

        try {
            setHideResolvedAlerts({ sortOrder: hideResolvedAlerts.sortOrder ?? 10, hidden: hideValue });

            // also reflect in localData so UI switches show correct state immediately
            setLocalData((prev) =>
                prev.map((item) => (item.value === 'hideResolvedAlerts' ? { ...item, hidden: hideValue } : item))
            );
        } catch (err) {
            console.debug('Failed to initialize hideResolvedAlerts from user settings', err);
        }
    }, [user]);

    // keep the User Settings toggle in sync with the global showResolved value
    useEffect(() => {
        try {
            // showResolved true means show resolved alerts -> hideResolvedAlerts.hidden should be false
            const newHidden = !showResolved;
            setHideResolvedAlerts((prev) => ({ sortOrder: prev.sortOrder ?? 10, hidden: newHidden }));
            setLocalData((prev) =>
                prev.map((item) => (item.value === 'hideResolvedAlerts' ? { ...item, hidden: newHidden } : item))
            );
        } catch (err) {
            console.debug('Failed to sync UserSettings hideResolvedAlerts from showResolved', err);
        }
    }, [showResolved]);

    const handleSwitches = (e, item) => {
        let tempData = [...localData];
        const idx = tempData.findIndex((a) => a.value === item.value);
        tempData[idx].hidden = !tempData[idx].hidden;
        setLocalData([...tempData]);

        // If toggling the Hide Resolved Alerts switch, update local user settings and atom so change is global
        if (item.value === 'hideResolvedAlerts') {
            try {
                // ensure userSettings is an object map
                let settings = user?.userSettings || {};
                if (Array.isArray(settings)) {
                    const map = {};
                    settings.forEach((s) => {
                        if (s && s.settingName) map[s.settingName] = s.value;
                    });
                    settings = map;
                }

                // widget value is the opposite of hidden
                const newHidden = tempData[idx].hidden;
                const widgetShowValue = `${!newHidden}`;

                const newSettings = { ...settings, widget_hideResolvedAlerts_Show: widgetShowValue };

                // update user context so ShowResolvedAlertsProvider reacts
                setUser({ ...user, userSettings: newSettings });

                // update jotai atom so settings UI reflects state where used
                setHideResolvedAlerts({ sortOrder: hideResolvedAlerts.sortOrder ?? 10, hidden: newHidden });

                // update the global context immediately so main pages react
                try {
                    // showResolved is the inverse of the "hide" flag
                    setShowResolved(!newHidden);
                } catch (err) {
                    console.debug('setShowResolved not available', err);
                }

                // persist to localStorage so the value survives page refresh
                try {
                    localStorage.setItem('widget_hideResolvedAlerts_Show', `${!newHidden}`);
                } catch (err) {
                    console.debug('Failed to persist hideResolvedAlerts to localStorage', err);
                }
            } catch (err) {
                console.debug('Failed to update hideResolvedAlerts setting locally', err);
            }
        }
    };

    const SortableUser = ({ user }) => {
        const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: user.id });
        const style = {
            transition,
            transform: CSS.Transform.toString(transform),
        };

        return (
            <div
                ref={setNodeRef}
                style={style}
                {...attributes}
                {...listeners}
                className="user bg-light mb-2 p-1 text-center">
                <div>{user.name}</div>
            </div>
        );
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id === over.id) {
            return;
        }
        setLocalData((localData) => {
            const oldIndex = localData.findIndex((user) => user.id === active.id);
            const newIndex = localData.findIndex((user) => user.id === over.id);
            return arrayMove(localData, oldIndex, newIndex);
        });
    };

    const saveAlertConfig = () => {
        let settingValues = {};

        const setSetting = (alert, index) => {
            let widgetSort = `widget_${alert.value}_SortOrder`;
            let widgetShow = `widget_${alert.value}_Show`;

            settingValues = {
                ...settingValues,
                [widgetSort]: index.toString(),
                // special-case hideResolvedAlerts: store the 'show' flag (inverse of hidden)
                [widgetShow]: alert.value === 'hideResolvedAlerts' ? `${!alert.hidden}` : `${!alert.hidden}`,
            };
        };

        localData.forEach((alert, index) => {
            setSetting(alert, index);
        });

        let newobj = {
            UserId: user.userId,
            settingValues,
        };

        SrxApi.post('/usersetting', newobj)
            .then((res) => {
                console.log(res);
                toast.success(res.data);
                Swal.fire({
                    title: 'Logout and log back in to apply changes?',
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: 'Logout and apply changes',
                    denyButtonText: `Apply changes later`,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        Swal.fire('changes will be applied when you log back in!', '', 'success');
                        logoutUser();
                    } else if (result.isDenied) {
                        Swal.fire('Changes will be applied next time you login', '', 'info');
                    }
                });
            })
            .catch((err) => toast.error('Error: ' + err.message));
    };
    alertTables = alertTables.sort((a, b) => (a.index < b.index ? -1 : b.index < a.index ? 1 : 0));

    return (
        <>
            <Container
                className="mt-5 mb-2 w-100 px-5 py-3 border border-light shadow-sm"
                style={{ borderRadius: '14px', minWidth: 'max-content' }}>
                <div className="d-flex justify-content-center">
                    <h3 className="text-center">Alerts dashboard configuration</h3>
                </div>
                <hr />
                {user?.userSettings?.allowToSetSettings === 'true' ? (
                    <>
                        <Row>
                            <Col xs={6}>
                                <div>
                                    <Form>
                                        <FormGroup>
                                            <div>
                                                {alertTables?.map((item, index) => (
                                                    <div className="mb-3">
                                                        <CustomInput
                                                            key={Math.random()}
                                                            type="switch"
                                                            id={'exampleCustomSwitch' + index}
                                                            name={item.value}
                                                            value={localData.find((i) => i.value === item.value)}
                                                            label={item.name}
                                                            checked={
                                                                item.value === 'hideResolvedAlerts'
                                                                    ? localData.find((i) => i.value === item.value)
                                                                          ?.hidden
                                                                    : !localData.find((i) => i.value === item.value)
                                                                          ?.hidden
                                                            }
                                                            onChange={(e) => handleSwitches(e, item)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </Col>
                            <Col xs={6} className="text-right float-right">
                                <div>
                                    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                        <SortableContext
                                            items={localData}
                                            strategy={rectSortingStrategy}
                                            reorderItems={arraySwap}
                                            getNewIndex={({ id, items, activeIndex, overIndex }) =>
                                                arraySwap(items, activeIndex, overIndex).indexOf(id)
                                            }>
                                            <div className="align-right">
                                                {localData
                                                    .filter(
                                                        (a) =>
                                                            !a.hidden &&
                                                            hasWidgetViewPermission(roles, a.permissionWidgetName)
                                                    )
                                                    .map((item, index) => (
                                                        <SortableUser key={index} user={item} />
                                                    ))}
                                            </div>
                                        </SortableContext>
                                    </DndContext>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="text-center mx-auto mt-5">
                                <Button onClick={saveAlertConfig}>Save Changes</Button>
                            </div>
                        </Row>
                    </>
                ) : (
                    <div className="text-center bg-light p-5 rounded">
                        <h4>your dashboard settings are managed by another user</h4>
                    </div>
                )}
            </Container>
        </>
    );
};

const ResetPasswordModal = ({ isOpen, toggle, user }) => {
    const [password, setPassword] = useState('');

    const [confirmPassword, setConfirmPassword] = useState('');

    function preToggle() {
        setPassword('');
        setConfirmPassword('');
        toggle();
    }

    const [invalidState, setInvalidState] = useState({
        password: false,
    });

    function resetPassword() {
        if (!password) {
            return setInvalidState({
                password: !password,
            });
        }

        if (password.length < 4) return;

        if (confirmPassword !== password) return;

        let payload = {
            email: user.email,
            password,
        };

        SrxApi.post('/edituserinfo', payload)
            .then((res) => {
                toast.success('User password updated');
                preToggle();
            })
            .catch((err) => {
                toast.error('Error: ' + err.message);
            });
    }

    return (
        <Modal isOpen={isOpen} toggle={preToggle} size={'md'}>
            <ModalHeader toggle={preToggle}>Reset Password</ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={9}>
                        <FormGroup>
                            <Label for="password">
                                New Password <small>*required</small>
                            </Label>
                            <Input
                                type="password"
                                name="password"
                                id="password"
                                className={`${
                                    (password && password.length < 4) || invalidState.password ? 'invalid' : ''
                                }`}
                                autoComplete="off"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => {
                                    if (e.target.value)
                                        setInvalidState({
                                            ...invalidState,
                                            password: false,
                                        });
                                    setPassword(e.target.value);
                                }}
                            />
                            {invalidState.password ? <div className="invalid-text">Password is required</div> : ''}
                            {password && password.length < 4 ? (
                                <div className="invalid-text">Password must be at least 4 characters long</div>
                            ) : (
                                ''
                            )}
                        </FormGroup>
                    </Col>
                    <Col md={9}>
                        <FormGroup>
                            <Label for="confirm-password">
                                Confirm New Password <small>*required</small>
                            </Label>
                            <Input
                                type="password"
                                name="confirm-password"
                                id="confirm-password"
                                className={`${
                                    password && confirmPassword && password !== confirmPassword ? 'invalid' : ''
                                }`}
                                autoComplete="off"
                                placeholder="Confirm password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            {password && confirmPassword && password !== confirmPassword ? (
                                <div className="invalid-text">Passwords do not match</div>
                            ) : (
                                ''
                            )}
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={preToggle}>
                    Cancel
                </Button>
                <Button color="primary" onClick={resetPassword}>
                    Save New Password
                </Button>
            </ModalFooter>
        </Modal>
    );
};

const MediprocitySignUp = (props) => {
    const { user, setUser } = useContext(UserContext);

    const { toggle } = props;

    const [editCredentials, setEditCredentials] = useState(false);

    useEffect(() => {
        toggle('specialtyRxNow');
    }, []);

    useEffect(() => {
        if (!editCredentials) {
            setMediprocityCredentials({
                user: '',
                password: '',
                encryptionKey: '',
            });
        }
    }, [editCredentials]);

    const [mediprocityCredentials, setMediprocityCredentials] = useState({
        user: '',
        password: '',
        encryptionKey: '',
    });

    function saveMediprocityCredentials(e) {
        e.preventDefault(e);

        SrxApi.post('/loginmediprocity', mediprocityCredentials)
            .then((res) => {
                setUser({
                    ...user,
                    mediprocityUser: 1,
                    mediprocityInfo: res.data.mediprocityInfo,
                });
                setMediprocityCredentials({
                    user: '',
                    password: '',
                    encryptionKey: '',
                });
                setEditCredentials(false);
                toast.success('Credentials successfully saved');
            })
            .catch((err) => toast.error(err.response?.data?.message || 'An error occurred'));
    }

    async function removeMediprocityCredentials() {
        if (
            (await confirm(
                'Remove SpecialtyRx Now credentials? This cannot be undone.',
                'Removing SpecialtyRx Now Credentials...',
                'Remove',
                'Cancel',
                'danger',
                'danger'
            )) === false
        )
            return;

        let removeMediprocityCredentialsToast = toast.loading('Removing SpecialtyRx Now credentials...', {
            theme: 'light',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });

        SrxApi.post('/clearMediprocity')
            .then(({ data }) => {
                toast.update(removeMediprocityCredentialsToast, {
                    render: data.message,
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                    hideProgressBar: null,
                    closeOnClick: null,
                });

                setUser({
                    ...user,
                    mediprocityUser: 0,
                    mediprocityInfo: {},
                });
            })
            .catch((err) => {
                toast.update(removeMediprocityCredentialsToast, {
                    render: err.response?.data?.message || 'An error occurred',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000,
                    hideProgressBar: null,
                    closeOnClick: null,
                });
            });
    }

    return (
        <Container
            className="mt-5 mb-2 w-50 px-5 py-3 border border-light shadow-sm"
            style={{ borderRadius: '14px', minWidth: 'max-content', minHeight: '' }}>
            <h3>SpecialtyRx Now Credentials</h3>
            <hr />
            {!user.mediprocityUser || editCredentials ? (
                <form autoComplete="new-password" onSubmit={saveMediprocityCredentials}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="user">User</Label>
                                <Input
                                    type="text"
                                    name="user"
                                    id="user"
                                    required
                                    autoComplete="new-password"
                                    value={mediprocityCredentials.user}
                                    onChange={(e) =>
                                        setMediprocityCredentials({
                                            ...mediprocityCredentials,
                                            user: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="password">Password</Label>
                                <Input
                                    type="password"
                                    name="password"
                                    id="password"
                                    required
                                    autoComplete="off"
                                    value={mediprocityCredentials.password}
                                    onChange={(e) =>
                                        setMediprocityCredentials({
                                            ...mediprocityCredentials,
                                            password: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label for="encryptionKey">Encryption Key</Label>
                                <Input
                                    type="password"
                                    name="encryptionKey"
                                    id="encryptionKey"
                                    required
                                    autoComplete="off"
                                    value={mediprocityCredentials.encryptionKey}
                                    onChange={(e) =>
                                        setMediprocityCredentials({
                                            ...mediprocityCredentials,
                                            encryptionKey: e.target.value,
                                        })
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-between">
                            {!!user.mediprocityUser && (
                                <Button
                                    type="button"
                                    color="link"
                                    className="px-0"
                                    onClick={() => setEditCredentials(false)}>
                                    Cancel
                                </Button>
                            )}
                            <Button type="submit" color="primary" className="ml-auto">
                                Save Credentials
                            </Button>
                        </Col>
                    </Row>
                </form>
            ) : (
                <div>
                    <Row>
                        <Col>
                            <Card className="text-white bg-success d-flex align-items-center">
                                <CardBody>
                                    <CardTitle tag="h3" className="mb-0 d-flex align-items-center">
                                        <span>SpecialtyRx Now Credentials Verified</span>
                                        <Icon icon={checkCircle} className="ml-2" />
                                    </CardTitle>
                                    {/* <CardText>
                                    With supporting text below as a natural lead-in to additional content.
                                </CardText>
                                <CardText>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a
                                    ante.
                                </CardText> */}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button color="link" className="px-0" onClick={removeMediprocityCredentials}>
                                Remove SpecialtyRx Now Credentials
                            </Button>
                        </Col>
                    </Row>
                </div>
            )}
        </Container>
    );
};

export default Settings;
